import type {
  HomeBatteryFunnelSettingsFields,
  HomeBatteryFunnelStep,
  HomeBatteryFunnelSettingsInterface,
} from '@innogy/feh/models';
import { initializeHomeBatteryFunnelStepAction } from '@feh/homebattery-store';
import {
  getLeadAddressFormControls,
  mapUsageQuestionnaire,
} from '@innogy/feh/shared';
import { FormGroup } from '@angular/forms';
import {
  RfaFormControl,
  RfaValidators,
  RfaComponents,
  RfaTransformers,
} from '@innogy/feh/rfa';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-angular';
import type {
  HomeBatteryWizardFormControls,
  HomeBatteryWizardRendering,
} from '@feh/homebattery-models';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';
import { mapGenericModalProperties } from '@legacy/common-ui-shared';

const defaultRequiredError = 'Veld verplicht';

export function initializeHomeBatteryFunnelComponent(
  step: HomeBatteryFunnelStep,
  funnelSettings: HomeBatteryFunnelSettingsFields | null | undefined
) {
  return initializeHomeBatteryFunnelStepAction({
    step,
    funnelSettings: mapHomeBatteryFunnelSettingsFields(funnelSettings),
  });
}

export function mapHomeBatteryFunnelSettingsFields(
  funnelSettingsFromSitecore: HomeBatteryFunnelSettingsFields | null | undefined
): HomeBatteryFunnelSettingsInterface | undefined {
  if (!funnelSettingsFromSitecore?.fields) {
    return undefined;
  }

  const {
    StartPage,
    OrderPage,
    SuccessPage,
    QuestionnairePage,
    UsageQuestionnaire,
    InfoContractType,
  } = funnelSettingsFromSitecore.fields;

  return {
    id: funnelSettingsFromSitecore.id,
    startPage: StartPage?.value,
    questionnairePage: QuestionnairePage?.value,
    orderPage: OrderPage?.value,
    successPage: SuccessPage?.value,
    usageWizard: mapUsageQuestionnaire(UsageQuestionnaire?.fields),
    infoContractType: mapGenericModalProperties(
      GenericModalSources.GENERIC_MODAL,
      InfoContractType?.fields
    ),
  };
}

export function createHomeBatteryForm(rendering: HomeBatteryWizardRendering) {
  const componentName = getFieldValue(
    rendering,
    'componentName',
    'thuisbatterij check'
  );
  return new FormGroup<HomeBatteryWizardFormControls>({
    address: new FormGroup(
      getLeadAddressFormControls(rendering, componentName)
    ),
    consumptionPerYear: new RfaFormControl(
      null,
      {
        label: getFieldValue(
          rendering,
          'ConsumptionPerYear',
          'Stroomverbruik per jaar'
        ),
        dataAutomationId: 'homebattery-wizard-form.consumptionPerYear',
        errorMsgs: {
          required: {
            msg: getFieldValue(
              rendering,
              'ConsumptionRequiredError',
              defaultRequiredError
            ),
            analytics: {
              componentName,
              description: getFieldValue(
                rendering,
                'ConsumptionRequiredError',
                defaultRequiredError
              ),
            },
          },
        },
        validators: [RfaValidators.required],
        transformers: [RfaTransformers.number()],
        analytics: {
          focusChangeTracker: {
            componentName,
          },
        },
      },
      RfaComponents.NumberInput
    ),
  });
}
